export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7677.9abc4838.jpg";